import { clone, findIndex, move } from "ramda";

interface Identifiable {
  id: string | number;
  [key: string]: unknown;
}

export function moveItemsInArray<T extends Identifiable, G extends Identifiable, H extends Identifiable>(
  collection: T[],
  from: G,
  to: H,
  identifier?: keyof T,
): T[] {
  if (!from || !to || !collection) {
    return collection;
  }

  const fromIndex = findIndex<T>((item) => String(item[identifier || "id"]) === String(from.id))(collection);
  const toIndex = findIndex<T>((item) => String(item[identifier || "id"]) === String(to.id))(collection);

  if (fromIndex !== toIndex) {
    return move(fromIndex, toIndex, collection);
  }

  return clone(collection);
}
